import { Layer } from '../../utility/Types/commonTypes';
import {
    REMOVE_ACTIVE_LAYER,
    SET_ACTIVE_LAYER_VISIBLE,
    REORDER_ACTIVE_LAYERS,
    SET_OR_CREATE_NEW_ACTIVE_LAYER,
    SET_OR_CREATE_NEW_ACTIVE_LAYERS,
    SET_ACTIVE_LAYER_PRINTABLE,
    SET_ALL_ACTIVE_LAYERS_PRINTABLE,
    HIDE_ACTIVE_LAYERS,
    REMOVE_ALL_LAYERS
} from './Types';
import { IActiveLayer } from './activeLayerTypes';

export const removeActiveLayer = (uid: string) => ({ type: REMOVE_ACTIVE_LAYER, uid });
export const setActiveLayerVisible = (uid: string, isVisible: boolean) => ({ type: SET_ACTIVE_LAYER_VISIBLE, uid, isVisible });
export const setActiveLayerPrintable = (uid: string, printable: boolean) => ({ type: SET_ACTIVE_LAYER_PRINTABLE, uid, printable });

export const hideActiveLayers = () => ({type: HIDE_ACTIVE_LAYERS})
export const removeAllLayers = () => ({type: REMOVE_ALL_LAYERS})

export const reorderActiveLayers = (reorderedLayers: IActiveLayer[]) => ({ type: REORDER_ACTIVE_LAYERS, reorderedLayers });

export const setOrCreateNewActiveLayer = (activeLayer: IActiveLayer, layer: Layer) => {
    return (dispatch: (arg0: { type: string; activeLayer: IActiveLayer; layer: Layer; }) => any) => {
        return dispatch({ type: SET_OR_CREATE_NEW_ACTIVE_LAYER, activeLayer, layer });
    };
};

// Bookmark/View turns on multiple at once - doesn't auto generate filters?
export const setOrCreateNewActiveLayers = (activeLayers: IActiveLayer[], layers: Layer[]) => {
    return (dispatch: (arg0: { type: string; activeLayers: IActiveLayer[]; layers: Layer[]; }) => any) => {
        return dispatch({ type: SET_OR_CREATE_NEW_ACTIVE_LAYERS, activeLayers, layers });
    };
};
export const setAllActiveLayersPrintable = (value: any) => ({ type: SET_ALL_ACTIVE_LAYERS_PRINTABLE, value });